var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-lg heading-container"},[_c('h1',{staticClass:"heading"},[_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/images-brand/kolm-noolt.svg"),"alt":_vm.$ls.Global_Alt_WaveBlue,"aria-hidden":"true"}}),_c('span'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }